import { RenderBatchSectionType } from '../Types/ForwardingBatchTypes';
import { BatchDetails } from './BatchSections/BatchDetails';
import { BatchMailItems } from './MailItems/BatchMailItems';
import { BatchContentsDeclaration } from './BatchSections/BatchContentsDeclaration';
import { BatchBatteryDeclaration } from './Batteries/BatchBatteryDeclaration';
import { BatchExportDetails } from './BatchSections/BatchExportDetails';
import { BatchNotes } from './Notes/BatchNotes';
import { BatchDocuments } from './Documents/BatchDocuments';
import { BatchLegal } from './BatchSections/BatchLegal';
import { BatchSignature } from './Signature/BatchSignature';

function RenderBatchSection(props: RenderBatchSectionType) {
	switch (props.section.sectionId) {
		case 0:
			return <BatchDetails {...props} />;
		case 1:
			return <BatchMailItems {...props} />;
		case 2:
			return <BatchContentsDeclaration {...props} />;
		case 3:
			return <BatchBatteryDeclaration {...props} />;
		case 4:
			return <BatchExportDetails {...props} />;
		case 5:
			return <BatchNotes {...props} />;
		case 6:
			return <BatchDocuments {...props} />;
		case 7:
			return <BatchLegal {...props} />;
		case 8:
			return <BatchSignature {...props} />;
		default:
			return null;
	}
}

export { RenderBatchSection };
